import React from "react";
import { Row } from "reactstrap";
import HeroUser from "../../../assets/images/DietPlans/hero-user.avif";
import LogoHome from "../../../assets/images/DietPlans/dark-logo.png";

const Header = () => {
  return (
    <section className="pt-1 py-xl-8 dietplan">
          <div className="container">
          <div className="row gy-5 gy-lg-0 align-items-lg-center justify-content-lg-between">
            <div className="col-12 d-flex justify-content-center hero-left-sec text-center">
                <div className="display-3 d-flex fw-bold mb-4 flex-column-reverse align-items-center w-75">
                  <div className="w-75">
                  <img
                    className="img-fluid dark-hero-img position-relative z-2 w-100 lg-w-75"
                    loading="lazy"
                    src={LogoHome}
                    alt="hero logo"
                    width="100%"
                    height="100%"
                  />
                  </div>
                  <div className="w-75" style={{ textAlign: 'right' }}>
                  <button
                    type="button"
                    className="btn btn-primary-home bsb-btn-3xl rounded-pill"
                  >
                    PRO
                  </button>
                  </div>
                </div>
                {/* <p className="mb-0 gray">
                  <span className="fst-italic">Optimize </span> Health with
                </p>
                <p className="mb-0 fw-bold gray">
                  Personalised AI Diet Plan
                </p> */}

                {/* <div className="d-grid gap-2 d-sm-flex pl-3 ms-3">
                  <ul className="list-group ml-4">
                    <li className="hero-li">1 lakh 67 thousand + kgs lost</li>
                    <li className="hero-li text-nowrap">12547+ lives transformed</li>
                  </ul>
                </div> */}
            </div>            
          </div>
        </div>
      </section>
  );
};

export default Header;
